import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  inspectors: [],
  addRatingStatus: 0,
  rating: {},
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
